// extracted by mini-css-extract-plugin
export default {"main":"TechnicianMain_main__E-Ind","aside":"TechnicianMain_aside__fb0VL","article":"TechnicianMain_article__XIezG"};